export const API_PATH_APPS = {
  // eslint-disable-next-line @typescript-eslint/naming-convention
  API_RISK_MAP: 'api-risk-map'
};
